/**
 * What the UI shows about updates (issue #3): one small observable store the launch and the
 * background check write and the About screen and the update indicator read.
 */
import type { Installed } from "./state";
import type { DownloadProgress } from "./update";

export type UpdateStatus =
  | { phase: "idle" }
  | { phase: "unsupported" }
  | { phase: "checking" }
  | { phase: "downloading"; progress: DownloadProgress; release: string }
  /** Staged and complete; `reason` says why the last launch kept it waiting, if it did. */
  | { phase: "ready"; staged: Installed; reason: string | null }
  | { phase: "shell-pending"; release: string }
  | { phase: "current"; checkedAt: string }
  | { phase: "offline"; checkedAt: string }
  | { phase: "failed"; error: string; checkedAt: string };

type Listener = (status: UpdateStatus) => void;

let current: UpdateStatus = { phase: "idle" };
const listeners = new Set<Listener>();

export function getUpdateStatus(): UpdateStatus {
  return current;
}

export function setUpdateStatus(status: UpdateStatus): void {
  current = status;
  for (const l of listeners) l(status);
}

export function subscribeUpdateStatus(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
